import { notEmptyString } from "./validators";

export const addBodyClass = (className: string, add = true) => {
  const cl = document.body.classList;
  const hasClass = cl.contains(className);
  if (!hasClass && add !== false) {
    cl.add(className);
  } else if (hasClass && add === false) {
    cl.remove(className);
  }
};

export const removeBodyClass = (className: string) => {
  addBodyClass(className, false);
};

export const validateSectionDom = (): {hasErrors: boolean; untitled: boolean; invalid: boolean} => {
  const hasErrors = document.querySelectorAll('.step-forms .field.error').length > 0;
  const untitled = document.querySelectorAll('.untitled').length > 0;
  const invalid = hasErrors || untitled;
  return {
    hasErrors,
    untitled,
    invalid,
  }
};

export const hasErrorInSection = (): boolean => {
  return validateSectionDom().hasErrors;
};

export const addScriptTag = (src = "", id='', crossOriginAnon = false, integrity = '') => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.setAttribute('src', src);
    if (id) {
      el.setAttribute('id', id)
    }
    if (crossOriginAnon) {
      el.setAttribute('crossorigin', 'anonymous')
    }
    const isModule = integrity === 'module';
    const type = isModule ? 'module' : 'text/javascript';
    const addIntegrity = !isModule && notEmptyString(integrity);
    if (addIntegrity) {
      el.setAttribute('integrity', integrity);
    }
    el.setAttribute('type', type);
    document.head.appendChild(el);
  }
  return el;
}
